var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"scrollable":"","persistent":""}},[_c('h-modifiers',{attrs:{"disabled":_vm.locked},on:{"complete":function($event){return _vm.$emit('complete')},"close":function($event){return _vm.$emit('input', false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }